import { ChatBubble } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconChatBubble12Line = createIcon(ChatBubble, 12, "Line");
export const IconChatBubble16Line = createIcon(ChatBubble, 16, "Line");
export const IconChatBubble20Line = createIcon(ChatBubble, 20, "Line");
export const IconChatBubble24Line = createIcon(ChatBubble, 24, "Line");
export const IconChatBubble32Line = createIcon(ChatBubble, 32, "Line");
export const IconChatBubble48Line = createIcon(ChatBubble, 48, "Line");
export const IconChatBubble64Line = createIcon(ChatBubble, 64, "Line");
